import React from "react";
import { useFormikContext } from "formik";
import { useEntityIdForGLAccount } from "@hooks/useEntityIdForGLAccount";
import { createTransactionsUrl } from "@components/transactions/lib/transactionsUrl";
import { useIsTransactionJournalEntry } from "@components/accounting/journalEntryDrawer/JournalEntryDrawerHooks";
import { useTransactionDetailsQuery } from "@components/transactions/TransactionDetails/useTransactionDetailsQuery";
import { getIntegerSourceId } from "@common/helpers/journalEntry";
import styles from "./JournalEntryDrawer.module.scss";
import { JournalEntryDrawerFormikConfig } from "./JournalEntryDrawer";

export const JournalEntryPersonalTransactionMessage: React.FC = () => {
    const { values } = useFormikContext<JournalEntryDrawerFormikConfig>();

    const isTransactionJournal = useIsTransactionJournalEntry(values);
    const transactionId = getIntegerSourceId(values.journalEntry.source);
    const { transaction: journalEntryTransaction } = useTransactionDetailsQuery(
        isTransactionJournal ? transactionId : null,
    );

    const glAccountEntityId = useEntityIdForGLAccount(journalEntryTransaction);

    const shouldShowMessage =
        journalEntryTransaction &&
        glAccountEntityId !== journalEntryTransaction.entityId;

    if (!shouldShowMessage) {
        return null;
    }

    const transactionsUrl = createTransactionsUrl({
        transactionIds: [journalEntryTransaction.id],
    });

    return (
        <p className={styles.personalTransactionMessage}>
            This transaction is marked as Personal. To edit the General Ledger,
            move it back to any Business entity from the{" "}
            <a href={transactionsUrl} target="_blank" rel="noopener noreferrer">
                Transactions
            </a>{" "}
            tab.
        </p>
    );
};
